module.exports = __webpack_public_path__ + "static/img/category-icon.2fd888a7.svg";